module.exports = __webpack_public_path__ + "static/media/spicy-dill-mama-dt-en.d90e8674.jpg";